import { render, staticRenderFns } from "./InstallAppPreview.vue?vue&type=template&id=48e28d68&scoped=true&"
import script from "./InstallAppPreview.vue?vue&type=script&lang=js&"
export * from "./InstallAppPreview.vue?vue&type=script&lang=js&"
import style0 from "./InstallAppPreview.vue?vue&type=style&index=0&id=48e28d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e28d68",
  null
  
)

export default component.exports